import React from 'react';
import defaultBG from '../../assets/projects/Background.png';
import CryptoImg from '../../assets/projects/CryptoApp.png';
import FoodipesImg from '../../assets/projects/Foodipes.png';
import LMSImg from '../../assets/projects/LMS.png';
import StockPipelineImg from '../../assets/projects/StockPipeline.png';
import VizIOTImg from '../../assets/projects/VizIOT.png';
import DiseasePredictionImg from '../../assets/projects/DiseasePrediction.png';
import WalletAppImg from '../../assets/projects/WalletAppUI.png'
import WeatherAppImg from '../../assets/projects/WeatherAppUI.png'
import PlantyAppImg from '../../assets/projects/PlantyAppUI.png'
import ContactAppImg from '../../assets/projects/ContactAppUI.png'
import YT_BG from '../../assets/projects/YT_BG.png'

import './Projects.css';


const ProjectCard = ({ info, delay }) => {
    const imageSrc = {
        'Background': defaultBG,
        'CryptoApp': CryptoImg,
        'Foodipes': FoodipesImg,
        'LMS': LMSImg,
        'StockPipeline': StockPipelineImg,
        'vizIOT': VizIOTImg,
        'DiseasePrediction': DiseasePredictionImg,
        'WalletAppUI': WalletAppImg,
        'WeatherAppUI': WeatherAppImg,
        'PlantyAppUI': PlantyAppImg,
        'ContactAppUI': ContactAppImg,
        'YT_BG': YT_BG
    };

    return (
    <div
      className="project-card"
      data-aos="zoom-in"
      data-aos-delay={delay}
      data-aos-once="true"
    >
      <div className="project-card-image">
        <img src={info?.image ? imageSrc[info?.image] : imageSrc['Background']} alt={info.name} draggable={false} />
      </div>
      <div className="project-card-body">
        <h4>{info.name}</h4>
        <p>{info.description}</p>
        {info.url && (
          <a
            className="project-card-link"
            href={info.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Code →
          </a>
        )}
        {info.demo && (
          <a
            className="project-card-link"
            href={info.demo}
            target="_blank"
            rel="noopener noreferrer"
          >
            Live Demo →
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;